import * as React from 'react';
import Box from '@mui/material/Box';
import SwipeableDrawer from '@mui/material/SwipeableDrawer';
import Button from '@mui/material/Button';
import List from '@mui/material/List';
import Divider from '@mui/material/Divider';
import ListItem from '@mui/material/ListItem';
import ListItemButton from '@mui/material/ListItemButton';
import ListItemIcon from '@mui/material/ListItemIcon';
import ListItemText from '@mui/material/ListItemText';
import { FaHome, FaInbox, FaVoicemail } from 'react-icons/fa';
import { RxTextAlignLeft } from 'react-icons/rx';
import { Link } from 'react-scroll'
import { FaCartArrowDown, FaFacebook, FaInstagram, FaLinkedin, FaSearch, FaTwitter, FaYoutube } from "react-icons/fa";
import logo from '../../images/logoslogan.png'

import { c1, pink, green } from '../../constants'

export default function SwipeableTemporaryDrawer() {

  const handleclick = () => {
    const link = "https://drive.google.com/file/d/1Xp-PJsVtK7eiU8Y6HhiMek20viEvHw0P/view?usp=sharing";
    window.open(link, '_blank', 'noreferrer');
  }

  const [state, setState] = React.useState({
    right: false,

  });

  const toggleDrawer = (anchor, open) => (event) => {
    if (
      event &&
      event.type === 'keydown' &&
      (event.key === 'Tab' || event.key === 'Shift')
    ) {
      return;
    }

    setState({ ...state, [anchor]: open });
  };

  const list = (anchor) => (
    <Box
      sx={{ width: anchor === 'top' || anchor === 'bottom' ? 'auto' : 300 }}
      role="presentation"
      onClick={toggleDrawer(anchor, false)}
      onKeyDown={toggleDrawer(anchor, false)}
    >
      <div style={{ padding: "30px", width: "100%", display: "flex", flexDirection: "row", justifyContent: "center" }}>
        <img src={logo} height="100px"></img>
      </div>

      <List>
        {[{ name: 'Home', to: "home" }, { name: 'About Us', to: "about" }, { name: 'Our Focus', to: "focus" }, { name: 'Teams', to: "teams" }, { name: 'Salaam Stree', to: "salaamstree" }, { name: 'Contact', to: "contact" }].map((item, index) => (
          <div key={index} style={{ display: "flex", flexDirection: "column" }}>
            <ListItem key={index} disablePadding>

              <ListItemButton onClick={toggleDrawer(anchor, false)}>
                <Link to={item.to} spy={true} style={{ width: "100%" }} smooth={true} offset={-100} duration={100} activeStyle={{ color: pink }} onClick={toggleDrawer(anchor, false)} >{item.name}</Link>



              </ListItemButton>

            </ListItem>

            <Divider></Divider>

          </div>

        ))}
      </List>

      {/* social icons */}
      <ul style={{ listStyle: "none", display: "flex", flexDirection: "row", justifyContent: "center", textDecoration: "none", gap: "20px", alignItems: "center", marginTop: "30px", paddingLeft: "0px" }}>

        <a href='https://twitter.com/StreeSafety' target="_blank" style={{ textDecoration: "none" }}> <FaTwitter style={{ fontSize: "20px", color: pink }}></FaTwitter> </a>
        <a href='https://www.facebook.com/people/STREE-Safety/100089926762389/' target="_blank" style={{ textDecoration: "none" }}> <FaFacebook style={{ fontSize: "20px", color: pink }}></FaFacebook> </a>
        <a href='https://www.instagram.com/streesafety/' target="_blank" style={{ textDecoration: "none" }}> <FaInstagram style={{ fontSize: "20px", color: pink }}></FaInstagram> </a>
        <a href='https://www.youtube.com/channel/UCVUvxFTWAsZM9h0PXpdQlOQ' target="_blank" style={{ textDecoration: "none" }}> <FaYoutube style={{ fontSize: "20px", color: pink }}></FaYoutube> </a>
        <a href='https://www.linkedin.com/company/streesafety/' target="_blank" style={{ textDecoration: "none" }}> <FaLinkedin style={{ fontSize: "20px", color: pink }}></FaLinkedin> </a>

      </ul>

      {/* actions */}
      <div style={{ display: "flex", justifyContent: "center", marginTop: "20px" }}>
        <div style={{ display: "flex", flexDirection: "row", alignItems: "center", width: "100%", margin: "10px" }}>

          <button style={{ padding: "10px", backgroundColor: "white", border: "1.5px solid", borderColor: green, borderRadius: "5px", color: green, fontWeight: "600", width: "100%", }} onClick={handleclick} >Empower Bharat</button>

        </div>
      </div>



    </Box>
  );

  return (
    <div>
      {['right'].map((anchor) => (
        <React.Fragment key={anchor}>
          <Button onClick={toggleDrawer(anchor, true)} style={{ height: "60px" }}> <RxTextAlignLeft size="25px" height="60px" style={{ color: c1, transform: "rotateY(180deg)" }}></RxTextAlignLeft></Button>
          <SwipeableDrawer
            anchor={anchor}
            open={state[anchor]}
            onClose={toggleDrawer(anchor, false)}
            onOpen={toggleDrawer(anchor, true)}
          >
            {list(anchor)}
          </SwipeableDrawer>
        </React.Fragment>
      ))}
    </div>
  );
}



export function SwipeableTemporaryDrawer_salaam() {

  const handleclick = () => {
    const link = "https://drive.google.com/file/d/1Xp-PJsVtK7eiU8Y6HhiMek20viEvHw0P/view?usp=sharing";
    window.open(link, '_blank', 'noreferrer');
  }

  const [state, setState] = React.useState({
    right: false,

  });

  const toggleDrawer = (anchor, open) => (event) => {
    if (
      event &&
      event.type === 'keydown' &&
      (event.key === 'Tab' || event.key === 'Shift')
    ) {
      return;
    }

    setState({ ...state, [anchor]: open });
  };

  const list = (anchor) => (
    <Box
      sx={{ width: anchor === 'top' || anchor === 'bottom' ? 'auto' : 300 }}
      role="presentation"
      onClick={toggleDrawer(anchor, false)}
      onKeyDown={toggleDrawer(anchor, false)}
    >
      <div style={{ padding: "30px", width: "100%", display: "flex", flexDirection: "row", justifyContent: "center" }}>
        <img src={logo} height="100px"></img>
      </div>

      <List>
        {[{ name: 'Home', to: "home" }, { name: 'About Us', to: "about" }, { name: 'Our Focus', to: "focus" }, { name: 'Teams', to: "teams" }, { name: 'Salaam Stree', to: "salaamstree" }, { name: 'Contact', to: "contact" }].map((item, index) => (
          <div key={index} style={{ display: "flex", flexDirection: "column" }}>
            <ListItem key={index} disablePadding>

              <ListItemButton onClick={toggleDrawer(anchor, false)}>
                <Link to={item.to} spy={true} style={{ width: "100%" }} smooth={true} offset={-100} duration={100} activeStyle={{ color: pink }} onClick={toggleDrawer(anchor, false)} >{item.name}</Link>



              </ListItemButton>

            </ListItem>

            <Divider></Divider>

          </div>

        ))}
      </List>

      {/* social icons */}
      <ul style={{ listStyle: "none", display: "flex", flexDirection: "row", justifyContent: "center", textDecoration: "none", gap: "20px", alignItems: "center", marginTop: "30px", paddingLeft: "0px" }}>

        <a href='https://twitter.com/StreeSafety' target="_blank" style={{ textDecoration: "none" }}> <FaTwitter style={{ fontSize: "20px", color: pink }}></FaTwitter> </a>
        <a href='https://www.facebook.com/people/STREE-Safety/100089926762389/' target="_blank" style={{ textDecoration: "none" }}> <FaFacebook style={{ fontSize: "20px", color: pink }}></FaFacebook> </a>
        <a href='https://www.instagram.com/streesafety/' target="_blank" style={{ textDecoration: "none" }}> <FaInstagram style={{ fontSize: "20px", color: pink }}></FaInstagram> </a>
        <a href='https://www.youtube.com/channel/UCVUvxFTWAsZM9h0PXpdQlOQ' target="_blank" style={{ textDecoration: "none" }}> <FaYoutube style={{ fontSize: "20px", color: pink }}></FaYoutube> </a>
        <a href='https://www.linkedin.com/company/streesafety/' target="_blank" style={{ textDecoration: "none" }}> <FaLinkedin style={{ fontSize: "20px", color: pink }}></FaLinkedin> </a>

      </ul>

      {/* actions */}
      <div style={{ display: "flex", justifyContent: "center", marginTop: "20px" }}>
        <div style={{ display: "flex", flexDirection: "row", alignItems: "center", width: "100%", margin: "10px" }}>

          <button style={{ padding: "10px", backgroundColor: "white", border: "1.5px solid", borderColor: green, borderRadius: "5px", color: green, fontWeight: "600", width: "100%", }} onClick={handleclick} >Empower Bharat</button>

        </div>
      </div>



    </Box>
  );

  return (
    <div>
      {['right'].map((anchor) => (
        <React.Fragment key={anchor}>
          <Button onClick={toggleDrawer(anchor, true)} style={{ height: "60px" }}> <RxTextAlignLeft size="25px" height="60px" style={{ color: c1, transform: "rotateY(180deg)" }}></RxTextAlignLeft></Button>
          <SwipeableDrawer
            anchor={anchor}
            open={state[anchor]}
            onClose={toggleDrawer(anchor, false)}
            onOpen={toggleDrawer(anchor, true)}
          >
            {list(anchor)}
          </SwipeableDrawer>
        </React.Fragment>
      ))}
    </div>
  );
}